import * as React from 'react';

export const useSpecialError = () => {
  const [specialError, setSpecialError] = React.useState<null | Error>(null);

  if (specialError) {
    throw specialError;
  }

  return setSpecialError;
};
